var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClassic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.90914 1.16699C4.68914 1.16699 2.07581 3.78033 2.07581 7.00033C2.07581 10.2203 4.68914 12.8337 7.90914 12.8337C11.1291 12.8337 13.7425 10.2203 13.7425 7.00033C13.7425 3.78033 11.1291 1.16699 7.90914 1.16699ZM7.90914 8.45866C7.10414 8.45866 6.45081 7.80533 6.45081 7.00033C6.45081 6.19533 7.10414 5.54199 7.90914 5.54199C8.71414 5.54199 9.36747 6.19533 9.36747 7.00033C9.36747 7.80533 8.71414 8.45866 7.90914 8.45866Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClassic);
export default __webpack_public_path__ + "static/media/classic.9f802a3eb8f7fb3c5c4f24af05d84bf2.svg";
export { ForwardRef as ReactComponent };